<template>
  <div v-if="!ready" class="fixed inset-0 flex items-center justify-center bg-background">
    <div class="h-8 w-8 animate-spin rounded-full border-4 border-muted border-t-primary" />
  </div>
  <RouterView v-else />
  <Toaster position="top-center" rich-colors close-button />
</template>

<script setup lang="ts">
import "vue-sonner/style.css";
import { ref, onMounted } from "vue";
import { RouterView, useRouter } from "vue-router";
import { Toaster } from "@/components/ui/sonner";

const router = useRouter();
const ready = ref(false);

onMounted(() => {
  router.isReady().then(() => {
    ready.value = true;
  });
});
</script>
